module.exports = __webpack_public_path__ + "img/IMG_0374_L_Foamcore_MockedUp.45ba8007.jpg";